/*------------------------------------*/
/*         LOGIN ERROR MESSAGES       */
/*------------------------------------*/

export const ERROR_MESSAGES = {
    'emptyField': 'emptyField',
    'invalidChac': 'No se admiten carácteres extraños',
    'nifFormat': 'nifFormat',
    'nifFecNac': 'Al menos uno de los campos DNI/NIE o fecha deben tener valores',
    'idbetisFormat': 'idbetisFormat',
    'invalidAuth': 'Credenciales inválidas o usuario no encontrado',
    'userSameId': 'Se ha encontrado más de un usuario con esas credenciales',
}

export const ERROR_CODES = ['emptyField',]